export abstract class ObservableStore<TSnapshot> {
  private readonly listeners = new Set<() => void>();
  private snapshot: TSnapshot;

  protected constructor(initialSnapshot: TSnapshot) {
    this.snapshot = initialSnapshot;
  }

  public subscribe = (listener: () => void): (() => void) => {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  };

  public getSnapshot = (): TSnapshot => this.snapshot;

  protected publish(changes: Partial<TSnapshot>): void {
    this.replace({ ...this.snapshot, ...changes });
  }

  protected replace(snapshot: TSnapshot): void {
    this.snapshot = snapshot;
    this.listeners.forEach((listener) => listener());
  }

  protected clearListeners(): void {
    this.listeners.clear();
  }
}
